import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=ef0b6d4e&scoped=true&lang=pug&"
import script from "./GlobalMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMenu.vue?vue&type=style&index=0&id=ef0b6d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0b6d4e",
  null
  
)

export default component.exports